export function GoogleCloudLogo({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.19 5.06h.52l2.3-2.3.11-.96C13.49.68 11.47.18 9.56.57 7.66.95 6.04 2.09 5.07 3.72a6.2 6.2 0 0 1 1.32-.22l4.6-.76s.24-.33.34-.33l.86 2.65z" fill="#EA4335"/>
      <path d="M18.95 7.72a8.4 8.4 0 0 0-2.53-3.1l-3.22 3.22a4.54 4.54 0 0 1 1.67 3.6v.46a2.28 2.28 0 0 1 0 4.55h-4.56l-.45.46v2.74l.45.45h4.56a6.87 6.87 0 0 0 4.08-12.38z" fill="#4285F4"/>
      <path d="M5.75 20.1h4.56v-3.65H5.75a2.23 2.23 0 0 1-.93-.2l-.64.2-1.83 1.83-.16.63a6.84 6.84 0 0 0 3.56.99v.2z" fill="#34A853"/>
      <path d="M5.75 6.37A6.87 6.87 0 0 0 2.2 18.9l2.63-2.63a2.28 2.28 0 1 1 3.02-3.44l2.63-2.63A6.85 6.85 0 0 0 5.75 6.37z" fill="#FBBC05"/>
    </svg>
  );
}
